import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const Services = () => {
  const mainServices = [
    {
      title: "DevOps & Cloud Automation",
      description: "Master the art of automation, deployment, and cloud infrastructure management. Learn industry-standard tools and practices.",
      features: [
        "CI/CD Pipeline Development",
        "Docker & Kubernetes",
        "AWS Cloud Services",
        "JFrog Artifactory",
        "SonarQube Code Quality",
        "Argo CD",
        "Terraform Infrastructure as Code",
        "Jenkins Automation",
        "Monitoring & Alerting"
      ],
      img: "/images/Devops.jpg",
      link: "/devops",
      icon: "☁️"
    },
    {
      title: "Full-Stack MERN Development",
      description: "Build modern, scalable web applications using the complete MERN stack. From frontend to backend, master every aspect of full-stack development.",
      features: [
        "React.js Frontend Development",
        "Node.js & Express.js Backend",
        "MongoDB Database Design",
        "RESTful API Development",
        "Modern UI/UX Design",
        "Deployment & Hosting"
      ],
      img: "/images/mern.jpg",
      link: "/fullstack",
      icon: "💻"
    },
    {
      title: "Automation Testing",
      description: "Learn how to build reliable, scalable test automation frameworks for web and API applications with real-world quality engineering practices.",
      features: [
        "Selenium Web Automation",
        "Playwright Testing",
        "API Testing with Postman",
        "BDD with Cucumber",
        "TestNG",
        "CI/CD Test Pipelines",
        "Bug Reporting & Defect Tracking",
        "Real-Time Project Practice"
      ],
      img: "/images/qa.jpg",
      link: "/automation-testing",
      icon: "🧪"
    },
    {
      title: "Job Assistance Program",
      description: "Comprehensive career support to help you land your dream job. From resume building to interview preparation, we've got you covered.",
      features: [
        "Resume Building & Optimization",
        "Mock Interview Sessions",
        "Portfolio Development",
        "Interview Preparation",
        "Career Guidance",
        "Industry Connections"
      ],
      img: "/images/job.png",
      link: "/job-assistance",
      icon: "🚀"
    }
  ];

  const additionalServices = [
    {
      title: "Project-Based Learning",
      description: "Work on real-world projects that showcase your skills and build your portfolio.",
      icon: "📚"
    },
    {
      title: "Mentorship Program",
      description: "Get personalized guidance from industry experts throughout your learning journey.",
      icon: "👨‍🏫"
    },
    {
      title: "Community Support",
      description: "Join a vibrant community of learners and professionals for networking and support.",
      icon: "👥"
    },
    {
      title: "Guaranteed Interview Support",
      description: "Qualified graduates receive interview introductions with our hiring partners and dedicated scheduling assistance to help you land interviews.",
      icon: "🎯"
    },
    {
      title: "24/7 Support",
      description: "Round-the-clock assistance for all your queries and technical issues.",
      icon: "🆘"
    }
  ];

  return (
    <Container className="page-shell services-page my-5">
      <Row className="mb-5 page-header">
        <Col>
          <span className="eyebrow dark">What we offer</span>
          <h1 className="text-center mb-3 fw-bold">Our Services</h1>
          <p className="page-subtitle text-center mx-auto">
            SPARKLOGIC offers comprehensive training programs designed to transform 
            you into a skilled professional. Explore our range of services below.
          </p>
        </Col>
      </Row>

      {/* Main Services */}
      <Row className="mb-5">
        <Col>
          <h2 className="text-center mb-4">Core Training Programs</h2>
          <Row className="g-4">
            {mainServices.map((service, index) => (
              <Col key={index} xs={12} lg={4}>
                <Card className="h-100 service-card border-0">
                  <div
                    className="service-image-wrap overflow-hidden"
                    style={{
                      height: "200px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#f8f9fa"
                    }}
                  >
                    <Card.Img
                      variant="top"
                      src={service.img}
                      alt={service.title}
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <Card.Body className="p-4">
                    <div className="d-flex align-items-center mb-3">
                      <span className="me-2" style={{ fontSize: "2rem" }}>
                        {service.icon}
                      </span>
                      <Card.Title className="mb-0">{service.title}</Card.Title>
                    </div>
                    <Card.Text className="text-muted mb-3">
                      {service.description}
                    </Card.Text>
                    <div className="mb-3">
                      <strong>What You'll Learn:</strong>
                      <ul className="feature-list mt-2 mb-0">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="mb-1">{feature}</li>
                        ))}
                      </ul>
                    </div>
                    <Button as={Link} to={service.link} variant="primary" className="w-100 service-btn">
                      Learn More
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>

      {/* Additional Services */}
      <Row className="mb-5">
        <Col>
          <h2 className="text-center mb-4">Additional Benefits</h2>
          <Row className="g-4 justify-content-center">
            {additionalServices.map((service, index) => (
              <Col key={index} xs={12} sm={6} md={4}>
                <Card className="h-100 info-card border-0 text-center">
                  <Card.Body className="p-4 d-flex flex-column justify-content-center">
                    <div className="mb-3" style={{ fontSize: "3rem" }}>
                      {service.icon}
                    </div>
                    <Card.Title>{service.title}</Card.Title>
                    <Card.Text className="text-muted">
                      {service.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>

      {/* Call to Action */}
      <Row>
        <Col>
          <Card className="cta-panel border-0 text-white">
            <Card.Body className="p-5 text-center">
              <h3 className="mb-3">Ready to Get Started?</h3>
              <p className="lead mb-4" style={{ color: "rgba(255,255,255,0.9)" }}>
                Choose the program that best fits your career goals and start your 
                journey towards becoming a skilled technology professional.
              </p>
              <Button as={Link} to="/pricing" variant="light" size="lg">
                View Pricing
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Services;

